import { Component, type ReactNode } from "react";

export class PageErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <section className="page-load-error" role="alert">
      <h1>This page could not load</h1>
      <p>Reload this page to get the latest version. If it still fails, check your connection or browser extensions.</p>
      <button type="button" className="primary-button" onClick={() => window.location.reload()}>Reload page</button>
    </section>;
  }
}
